module.exports = __webpack_public_path__ + "img/icon-error.c65f503c.png";